import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { viewPortBreakpoints } from "ui/styles/viewport";

export const Name = styled.h3`
  overflow-wrap: break-word;
  width: 100%;
  margin: 0 0 36px;
  ${Fonts.semiBold_20}
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const FieldLabel = styled.span`
  display: block;
  width: 100%;
  margin-bottom: 8px;
  ${Fonts.SEMIBOLD_12}
  color: ${(p) => p.theme.textMediumContrast};
`;

export const FieldValue = styled.span`
  ${Fonts.regular_16}
  overflow-wrap: break-word;
  width: 100%;
`;

export const Separator = styled.hr`
  width: 100%;
  margin: 8px 0;
  border: 1px solid ${(p) => p.theme.borderHighContrast};
  border-bottom: none;

  @media (min-width: ${viewPortBreakpoints.xl}) {
    margin: 12px 0;
  }
`;
